<script setup>
import { ref } from 'vue'
import { getAllTimezones } from 'countries-and-timezones'

const props = defineProps({
  modelValue: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const allTimezones = Object.values(getAllTimezones()).map(tz => ({
  label: `(GMT${tz.utcOffsetStr}) ${tz.name.replace(/_/g, ' ')}`,
  value: tz.name
}))

allTimezones.sort((a, b) => a.label.localeCompare(b.label))

const filteredOptions = ref(allTimezones)

const filterFn = (val, update) => {
  update(() => {
    if (val === '') {
      filteredOptions.value = allTimezones
    } else {
      const needle = val.toLowerCase()
      filteredOptions.value = allTimezones.filter(
        v => v.label.toLowerCase().includes(needle)
      )
    }
  })
}

const onUpdate = (val) => {
  emit('update:modelValue', val)
  emit('change', val)
}
</script>

<template>
  <div class="timezone-selector">
    <q-select
      :model-value="props.modelValue"
      :options="filteredOptions"
      :label="$t('common.timezone')"
      use-input
      fill-input
      hide-selected
      input-debounce="0"
      hide-bottom-space
      emit-value
      map-options
      @filter="filterFn"
      @update:model-value="onUpdate"
    >
      <template #no-option>
        <q-item>
          <q-item-section class="text-grey">
            {{ $t('auth.errors.noResultsFound') }}
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>
